import React from "react";
import typography from '../img/typography.jpg'


class Quiz extends React.Component{
    render(){
        return(
            <div className="quiz">
                <header className="quiz__header">
                    <button className="btn__cross"><span className="cross"></span></button>
                    <div className="proggress__bar"><div className="proggress__now"></div></div>
                </header>
                <div className="quiz__zone">
                    <h2 className="quiz__question">Какая задача стоит у хорошей типографики</h2>
                    <img src={typography}  alt=''/>
                    <div className="quiz__radio__zone">
                        <div className="quiz__radio">Внешняя привлекательность</div>
                        <div className="quiz__radio">Читабильность</div>
                        <div className="quiz__radio">Разборчивость</div>
                        <div className="quiz__radio">Все вышеперечисленное</div>
                    </div> 
                    <button className="btn btn__quiz" disabled>Продолжить</button>               
                </div>
            </div>
        )
    }
}


export default Quiz